import api from '@/plugins/request/index';
import { param } from 'jquery';
// 添加客户数据
export const customeAdd = async (params, type = 'post') => {
  return api[type]('/gateway/v1/customer', params).then(res => res);
}
// 编辑客户数据
export const customeEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/customer/${id}`, params).then(res => res);
}
// 获取客户详情
export const getCustomByIdApi =  async (id, type = 'get') => {
  return api[type](`/gateway/v1/customer/${id}`).then(res => res);
}
// 获取公客池列表
export const myPublicCustomeList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/customer/public-customer', params).then(res => res);
}
// 获取公客池列表导出
export const myPublicCustomeListExport = async (params, type = 'get') => {
  return api[type]('/gateway/v1/customer/public-customer/export', params).then(res => res);
}
// 公客池分配
export const myPublicDistictUser = async (params, type = 'put') => {
  return api[type]('/gateway/v1/customer/public-allocation', params).then(res => res);
}
// 公客池批量分配
export const myPublicDistictUserBatch = async (params, type = 'put') => {
  return api[type]('/gateway/v1/customer/batch-public-allocation', params).then(res => res);
}
// 客户详情-联系人列表
export const customConcatList = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/customer/info/contact/${id}`, params).then(res => res);
}
// 客户详情-添加联系人
export const customeConcatAdd = async (params, type = 'post') => {
  return api[type](`/gateway/v1/customer/contact`, params).then(res => res);
}
// 客户详情-修改联系人
export const customeConcatEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/customer/contact/${id}`, params).then(res => res);
}
// 客户详情-设为主联系人
export const customeConcatSetMain = async (customeId, id, type = 'put') => {
  return api[type](`/gateway/v1/customer/contact/${customeId}/${id}/set-main`).then(res => res);
}
// 客户详情-商机列表
export const customeBussinessList = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/customer/info/business/${id}`, params).then(res => res);
}
// 客户详情-报备楼盘
export const customeBussinessReport = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/apply-report`, params).then(res => res);
}
// 客户详情-报备楼盘-批量添加楼盘
export const customeBussinessReportBatch = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/batch-apply-report`, params).then(res => res);
}
// 客户详情-订单列表
export const customeOrderList = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/customer/info/order/${id}`, params).then(res => res);
}
// 客户详情-跟进列表
export const customeFollowList = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/customer/info/follow/${id}`, params).then(res => res);
}
// 客户详情-写跟进
export const customeFollowAdd = async (params, type = 'post') => {
  return api[type](`/gateway/v1/customer/follow`, params).then(res => res);
}
// 客户详情-操作列表
export const customeOperateList = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/customer/info/operation/${id}`, params).then(res => res);
}
// 客户详情-操作列表
export const customeBelongList = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/customer/info/owner/${id}`, params).then(res => res);
}
// 客户详情-申请锁定
export const customeApplyLock = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/apply-lock`, params).then(res => res);
}
// 客户详情-申请转入无效池
export const customeApplyInvalid = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/apply-invalid`, params).then(res => res);
}
// 客户详情-申请撞客
export const customeApplyHit = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/apply-collision`, params).then(res => res);
}
// 客户详情-申请转入黑名单
export const customeApplyBlack = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/apply-black`, params).then(res => res);
}
// 客户详情-申请转入公客池
export const customeApplyPublic = async (params, type = 'put') => {
  return api[type](`/gateway/v1/customer/shift-public`, params).then(res => res);
}
// 私客池列表
export const getPrivateCustome = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/private-customer`, params).then(res => res);
}
// 私客池列表导出
export const privateCustomeExport = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/private-customer/export`, params).then(res => res);
}
// 获取批量导入模板列表
export const getTemplateList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/template`, params).then(res => res);
}
// 删除模板
export const removeTemplate = async (id, type = 'delete') => {
  return api[type](`/gateway/v1/customer/template/${id}`).then(res => res);
}
// 获取模板初始化字段
export const getTemplateInit = async (id, type = 'get') => {
  return api[type](`/gateway/v1/customer/template/fields/${id}`).then(res => res);
}
// 获取上传excel问价表头
export const getExcelHeader = async (params, type = 'post') => {
  return api[type](`/gateway/v1/customer/template/import-title`, params).then(res => res);
}
// 根据模板id获取编辑的模板详情
export const getTemplateById = async (id, type = 'get') => {
  return api[type](`/gateway/v1/customer/template/${id}`).then(res => res);
}
// 将指定路径文件导入
export const importFileToSystem = async (params, type = 'post') => {
  return api[type](`/gateway/v1/customer/template/import-body`, params, {
    timeout: 60000,
    headers: {
      timeout: 60000,
    }
  }).then(res => res);
}
// 添加模板
export const addTemplate = async (params, type = 'post') => {
  return api[type](`/gateway/v1/customer/template`, params).then(res => res);
}
// 编辑模板
export const editTemplate = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/customer/template/${id}`, params).then(res => res);
}
// 将文件导入模板
export const importFile = async (params, type = 'post') => {
  return api[type](`/gateway/v1/admin/import-body`, params).then(res => res);
}
// 获取模板详情
export const getTemplateDetail = async (id, type = 'get') => {
  return api[type](`/gateway/v1/customer/template/${id}/title`).then(res => res);
}
// 申请认筹
export const applyRecongnition = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/apply-recognition`, params).then(res => res);
}
// 申请认购
export const applySubscribe = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/apply-subscription`, params).then(res => res);
}
// 申请带看
export const applyTakeLook = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/apply-look`, params).then(res => res);
}
// 获取订单的最近审批单信息
export const getOrderApprove = async (params, type = 'get') => {
  return api[type](`/gateway/v1/approval/recent-order-voucher`, params).then(res => res);
}
// 公客池抢客
export const publicPoolTakeUser = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/customer/${id}/take-from-public`, params).then(res => res);
}
// 解锁
export const userUnLock = async (params, type = 'put') => {
  return api[type](`/gateway/v1/customer/unlock`, params).then(res => res);
}
// 从无效池、黑名单移出
export const userMoveOut = async (params, type = 'put') => {
  return api[type](`/gateway/v1/customer/${params.ids}/move-out`, params).then(res => res);
}
// 从无效池、黑名单批量移出
export const userMoveOutBatch = async (params, type = 'put') => {
  return api[type](`/gateway/v1/customer/batch-move-out`, params).then(res => res);
}
// 检查客户是否存在
export const getUserExits = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/contact/check-tel`, params).then(res => res);
}
// 申请合并客户
export const applyMergeCustome = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/apply-merge`, params).then(res => res);
}
// 获取无效池列表
export const getInvalidList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/invalid-customer`, params).then(res => res);
}
// 获取无效池列表导出
export const invalidListExport = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/invalid-customer/export`, params).then(res => res);
}
// 获取黑名单列表
export const getBlackList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/black-customer`, params).then(res => res);
}
// 获取黑名单列表导出
export const blackListExport = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/black-customer/export`, params).then(res => res);
}
// 客户等级记录
export const customerLevelList = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/customer/info/level-log/${id}`, params).then(res => res);
}
// 经纪人全部客户转让给其他经纪人
export const adminTransformToOther = async (params, type = 'put') => {
  return api[type](`/gateway/v1/customer/batch-giving`, params).then(res => res);
}
// 经纪人客户转让给其他经纪人
export const adminTransformToOtherMember = async (params, type = 'put') => {
  return api[type](`/gateway/v1/customer/batch-giving-v2`, params).then(res => res);
}
// 获取跟进记录详情
export const getFollowDetailById = async (id, type = 'get') => {
  return api[type](`/gateway/v1/log/follow/${id}`).then(res => res);
}
// 检查是否有查看客户详情的权限
export const getDetailPermission = async (id, type = 'get') => {
  return api[type](`/gateway/v1/customer/${id}/check-permission`).then(res => res);
}
// 获取客户等级描述
export const getLevelDesc = async (params, type = 'get') => {
  return api[type](`/gateway/v1/company/config`, params).then(res => res);
}
// 经纪人修改自身头像
export const setAvatar = async (params, type = 'put') => {
  return api[type](`/gateway/v1/admin/avatar`, params).then(res => res);
}
// 企微客户列表
export const getClewCustomeList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/we-work/external-contact`, params).then(res => res);
}
// 企微客户列表
export const updateClewCustome = async (type = 'post') => {
  return api[type](`/gateway/v1/we-work/syn-external-contact`).then(res => res);
}
// 企微客户标签列表
export const getClewTagList = async (type = 'get') => {
  return api[type](`/gateway/v1/we-work/external-contact/tag`).then(res => res);
}
// 企微线索详情
export const getClewDetailById = async (clew_id, params,  type = 'get') => {
  return api[type](`gateway/v1/we-work/external-contact/${clew_id}`, params).then(res => res);
}
// 企微线索详情
export const getClewFollowList = async (admin_id, clew_id,params, type = 'get') => {
  return api[type](`/gateway/v1/admin/${admin_id}/wework_customer/${clew_id}/info/follow`, params).then(res => res);
}
// 企微线索详情
export const getClewOperateList = async (admin_id, clew_id,params, type = 'get') => {
  return api[type](`/gateway/v1/admin/${admin_id}/wework_customer/${clew_id}/info/operation`, params).then(res => res);
}
// 企微线索详情
export const getClewLevelList = async (admin_id, clew_id,params, type = 'get') => {
  return api[type](`/gateway/v1/admin/${admin_id}/wework_customer/${clew_id}/info/level-log`, params).then(res => res);
}
// 企微线索编辑
export const updateClew = async (clew_id,params, type = 'put') => {
  return api[type](`/gateway/v1/we-work/external-contact/${clew_id}`, params).then(res => res);
}
// 企微线索跟进
export const addClewFollow = async (params, type = 'post') => {
  return api[type](`/gateway/v1/wework_customer/follow`, params).then(res => res);
}
// 企微线索跟进详情
export const getClewFollowDetail = async (lid, type = 'get') => {
  return api[type](`/gateway/v1/we_work/log/follow/${lid}`).then(res => res);
}
// 检测企微线索是否合理
export const checkClewInfo = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/we-work/external-contact/${id}/check`, params).then(res => res);
}
// 企微线索转让客户
export const clewTransformToCustome = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/we-work/external-contact/${id}/trans`, params).then(res => res);
}
// 访客列表
export const getVisitorList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/shop-visitor`, params).then(res => res);
}
// 合并访客列表
export const getVisitorConcatList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/shop-visitor-merge`, params).then(res => res);
}
// 判断访客列表转换类型
export const getConvertType = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/shop-visitor/${id}/trans`, params).then(res => res);
}
// 访客详情
export const getVisitorDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/shop-visitor/${id}`, params).then(res => res);
}
// 访客解绑
export const unbindVisitorInfo = async (id, type = 'put') => {
  return api[type](`/gateway/v1/shop-visitor/${id}/cancel-bind`).then(res => res);
}
// 访客浏览轨迹列表
export const getVisitorTrackList = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/shop-visitor/${id}/trace`, params).then(res => res);
}
// 访客智能分析
export const getVisitorAnalysis = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/shop-visitor/${id}/explain`, params).then(res => res);
}
// 访客保存备注更新
export const visitorUpdateRemark = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/shop-visitor/${id}/remark`, params).then(res => res);
}
// 旅程列表
export const getGunrneyList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/customer-route-logs`, params).then(res => res);
}
// 检测企微详情权限
export const getEnterPrisePermission = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/we-work/external-contact/${id}/check-info`, params).then(res => res);
}
// 检测云门店详情权限
export const getVisitorPermission = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/shop-visitor/${id}/check-info`, params).then(res => res);
}
// 旅程操作人列表
export const getGunrneyAdmin = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/customer-route-operators`, params).then(res => res);
}
// 旅程-下载400录音
export const downloadCallRecord = async (id, type = 'put') => {
  return api[type](`/gateway/v1/log/download-route-call/${id}`, {}, {
    timeout: 60 * 1000
  }).then(res => res);
}
// 旅程-下载播放前置检查
export const downloadPreCheck = async (id, type = 'get') => {
  return api[type](`/gateway/v1/log/download-route-call/${id}/pre-check`, {}, {
    timeout: 60 * 1000
  }).then(res => res);
}
// 旅程-查询IM聊天记录
export const getImRecordList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/im/history/msg-list`, params).then(res => res);
}
// 旅程-查看IM聊天授权状态
export const getImAuthStatus = async (params, type = 'get') => {
  return api[type](`/gateway/v1/im/history/auth-card`, params).then(res => res);
}
// 旅程-查看IM聊天总数
export const getImCount = async (params, type = 'get') => {
  return api[type](`/gateway/v1/im/history/msg-count`, params).then(res => res);
}
// 新客池-待分配列表
export const getGuestCustomer = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/new-customer`, params).then(res => res);
}
// 新客池-待分配列表导出
export const guestCustomerExport = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/new-customer/export`, params).then(res => res);
}
// 新客池-客户分配到私客池
export const setGuestDistribution = async (params, type = 'put') => {
  return api[type](`/gateway/v1/customer/distribution`, params).then(res => res);
}
// 新客池-抢客操作
export const guestTakeUser = async (params, type = 'put') => {
  return api[type](`/gateway/v1/customer/new-grab`, params).then(res => res);
}
// 新客池-待分配导出
export const exportYorkerBeDistri = '/gateway/v1/customer/new-customer/export';
// 新客池-待抢客列表
export const getYorkerBeGuestList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/resident-customer/pending-list`, params).then(res => res);
}
// 新房卡-抢客操作
export const robeYorkerGuest = async (params, type = 'put') => {
  return api[type](`/gateway/v1/resident-customer/grab`, params).then(res => res);
}
// 新客池-抢客结果列表
export const getYorkerResultList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/resident-customer/record-list`, params).then(res => res);
}
// 新客池-搜索平台
export const getPlatformSelect = async (type = 'get') => {
  return api[type](`/gateway/v1/company/platform-for-selected`).then(res => res);
}
// 新客池-归属记录列表
export const getYorkerRecordeList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/distribute-logs`, params).then(res => res);
}
// 新客池-归属记录导出
export const exportYorkerRecord = async (params, type = 'get') => {
  return api[type]('/gateway/v1/customer/distribute-logs/export', params).then(res => res);
}
// 客户现有协助人
export const getCustomeHasHelper = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/customer/${id}/helper`, params).then(res => res);
}
// 新增协助人
export const addCustomeHasHelper = async (params, type = 'post') => {
  return api[type](`/gateway/v1/customer/helper`, params).then(res => res);
}
// 移除协助人
export const removeCustomeHasHelper = async (params, type = 'put') => {
  return api[type](`/gateway/v1/customer/helper/cancel`, params).then(res => res);
}
// 退出协助人
export const outCustomeHasHelper = async (id, type = 'put') => {
  return api[type](`/gateway/v1/customer/${id}/helper/exit`).then(res => res);
}
// 客户管理-移交客户
export const customeTransfer = async (params, type = 'put') => {
  return api[type](`/gateway/v1/customer/transfer`, params).then(res => res);
}
// 客户管理-批量移交客户
export const customeTransferBatch = async (params, type = 'put') => {
  return api[type](`/gateway/v1/customer/batch-transfer`, params).then(res => res);
}
// 客户管理平台轨迹列表
export const customeLogPlatformTrack = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/platform-tracks`, params).then(res => res);
}
// 轨迹列表是否存在数据
export const isPlatformTrack = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/platform-tracks/check`, params).then(res => res);
}
export const downloadCaculate = async (params, type = 'post') => {
  return api[type](`/gateway/v1/log/customer_list_pre_check`, params).then(res => res);
}

//抖音访客
export const getYunVisitor = async (params, type = 'get') => {
  return api[type](`/gateway/v1/douyin/visitors`, params).then(res => res);
}
// 抖音访客导出
export const exportDyVisitorRecord = async (params, type = 'get') => {
  return api[type]('/gateway/v1/douyin/visitors/export', params).then(res => res);
}
//抖音访客详情
export const getYunVisitorById = async (id, type = 'get') => {
  return api[type](`/gateway/v1/douyin/visitor/${id}`).then(res => res);
}
//抖音访客轨迹
export const getYunVisitorTrace = async (params, type = 'get') => {
  return api[type](`/gateway/v1/douyin/visitor/trace`, params).then(res => res);
}